<div class="col-xs-12 PibannerUk" id="uk_Pi_Banner"><a (click)="handleClick()">{{paracontent}} <img alt="Next screen" src="assets/images/arrow-right-white.svg"></a></div>
